import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const NikIndonesia = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { nik, errors } = formState;

  const inputElements = [
    {
      belongsTo: ['Indonesia Resident Identity Card', 'Indonesia Tax Registration'],
      element: (
        <TextFieldGroup
          key="nik"
          id="nik"
          type="text"
          name="nik"
          dataName="nikID"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.nik')}
          value={nik}
          placeholder={transUTL('translatePlaceholder.inputID.nik')}
          placeholderTrigger={isEmptyVAL(nik) ? 'input-empty' : ''}
          error={errors.nik}
          errorTrigger={errors.nik ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

NikIndonesia.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default NikIndonesia;
